// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Singleton<T extends { new (...args: any[]): any }>(ctr: T) {
  let instance: T;

  return class extends ctr {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args: any[]) {
      if (instance) {
        return instance;
      }
      super(...args);
      instance = this as unknown as T;
    }
  };
}
